export class TurnoFuncionarioUACModel {

    public tipoDocumentoFuncionario: string;
    public numeroDocumentoFuncionario: string;
    public nombreDependencia: string;
    public idDependencia:string;
    public correo: string;
    public cargo: string;
    public tipoFuncionario: string;
    public telefono: string;
    public nombreCompleto: string;
    public horaInicioAtencion :any;
    public horaFinAtenciona:any;

}